export const MAKE_POST = "MAKE_POST";
export const POST_ERROR = "POST_ERROR";
export const GET_USER_POSTS = "GET_USER_POSTS";
export const REMOVE_POST = "REMOVE_POST";
export const GET_POSTS = "GET_POSTS";
export const GET_POST = "GET_POST";
export const CLEAR_POSTS = "CLEAR_POSTS";
export const CLEAR_POST = "CLEAR_POST";
export const SEARCH_TOPICS = "SEARCH_TOPICS";
export const MOST_LIKED_POSTS = "MOST_LIKED_POSTS";
export const MOST_COMMENTED = "MOST_COMMENTED";
export const ADD_LIKE = "ADD_LIKE";
export const THE_MOST_RECENT_POSTS = "THE_MOST_RECENT_POSTS"
export const REMOVE_LIKE = "REMOVE_LIKE";
export const ADD_COMMENT = "ADD_COMMENT";
export const GET_POST_BY_USER_ID = "GET_POST_BY_USER_ID";
export const LIKE_COMMENT = "LIKE_COMMENT";
export const REMOVE_LIKE_FROM_COMMENT = "REMOVE_LIKE_FROM_COMMENT";
export const REMOVE_COMMENT = "REMOVE_COMMENT"
